export const INSERT_LOCATION = 'INSERT_LOCATION'
export const INSERT_ALL_LOCATIONS = 'INSERT_ALL_LOCATIONS'
export const UPDATE_LOCATION = 'UPDATE_LOCATION'
export const DELETE_LOCATION = 'DELETE_LOCATION'